import { PayloadAction } from 'interfaces/action'
import { Timeframe } from 'interfaces/chart'
import { PeergroupsTyped } from 'interfaces/peergroups'
import { createPayloadAction } from 'helpers/actionsHelpers'
import { GenericTrendType } from 'interfaces/pages'
import { GenericTrendPayload, PeergroupTrendCollection, Trend } from 'interfaces/trend'

type GetGenericTrendPayload = {
  type: GenericTrendType
  timeframe: Timeframe
}
export const GET_MEMBER_GENERIC_TRENDS = 'GET_MEMBER_GENERIC_TRENDS' as const
type GetMemberGenericTrends = PayloadAction<typeof GET_MEMBER_GENERIC_TRENDS, GetGenericTrendPayload>
export const getMemberGenericTrendsActionCreator = (type: GenericTrendType, timeframe: Timeframe): GetMemberGenericTrends =>
  createPayloadAction(GET_MEMBER_GENERIC_TRENDS, { type, timeframe })

export const SET_MEMBER_GENERIC_TRENDS = 'SET_MEMBER_GENERIC_TRENDS' as const
type SetMemberGenericTrends = PayloadAction<typeof SET_MEMBER_GENERIC_TRENDS, GenericTrendPayload<Trend>>
export const setMemberGenericTrendsActionCreator = (type: GenericTrendType, timeframe: Timeframe, data: Trend): SetMemberGenericTrends =>
  createPayloadAction(SET_MEMBER_GENERIC_TRENDS, { type, timeframe, data })

type GetPeergroupsGenericTrendsPayload = GetGenericTrendPayload & PeergroupsTyped
export const GET_PEER_GROUP_GENERIC_TRENDS = 'GET_PEER_GROUP_GENERIC_TRENDS' as const
type GetPeergroupsGenericTrends = PayloadAction<typeof GET_PEER_GROUP_GENERIC_TRENDS, GetPeergroupsGenericTrendsPayload>
export const getPeergroupsGenericTrendsActionCreator = (type: GenericTrendType, timeframe: Timeframe, peergroups: number[]): GetPeergroupsGenericTrends =>
  createPayloadAction(GET_PEER_GROUP_GENERIC_TRENDS, { type, timeframe, peergroups })

export const APPEND_PEER_GROUP_GENERIC_TRENDS = 'APPEND_PEER_GROUP_GENERIC_TRENDS' as const
type AppendPeergroupsGenericTrends = PayloadAction<typeof APPEND_PEER_GROUP_GENERIC_TRENDS, GenericTrendPayload<PeergroupTrendCollection>>
export const appendPeergroupsGenericTrendsActionCreator = (type: GenericTrendType, timeframe: Timeframe, data: PeergroupTrendCollection): AppendPeergroupsGenericTrends =>
  createPayloadAction(APPEND_PEER_GROUP_GENERIC_TRENDS, { type, timeframe, data })

export type Action =
  | GetMemberGenericTrends
  | SetMemberGenericTrends
  | GetPeergroupsGenericTrends
  | AppendPeergroupsGenericTrends

export default Action
